<div id="homeBase" class="pageBox" [class.pb-0]="!showFooter">
    <router-outlet></router-outlet>
    <app-pwa-prompt-events *ngIf="showPWA && showFooter"></app-pwa-prompt-events>
    <app-footer *ngIf="showFooter"></app-footer>
</div>